import React, { useEffect } from "react";
import NavbarHome from "../components/navbar-home";
import About from "../pages/Home/about";
import Feature from "../pages/Home/feature";
import Jumbutron from "../pages/Home/jumbotron";
import List from "../pages/Home/list";
import Galery from "../pages/Home/galery";
import Renovasion from "../pages/Home/renovation";
import Notation from "../pages/Home/notation";
import Footer from "../components/footer";

export default function LandingPage() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <div className="overflow-x-hidden">
      <NavbarHome />
      <Jumbutron />
      <Feature />
      <List />
      <About />
      <Galery />
      <Renovasion />
      <Notation />
      <Footer />
    </div>
  );
}
